var _templateObject = _taggedTemplateLiteralLoose(['\n  border-radius: 0px;\n  padding: 15px 20px;\n  cursor: pointer;\n  /* font-family: \'Montserrat, Arial, sans-serif\'; */\n  background-color:  ', ';\n  color:  ', ';\n  background: ', ';\n  border: 1px solid #6CB557;\n  text-transform: uppercase;\n  transition: ', ';\n  position: relative;\n  &:hover {\n    color: #fff;\n    background: linear-gradient(90deg,#009677 0,#50b848 100%);\n    &:before {\n      content: \'\';\n      display: block;\n      height: 10px;\n      width: calc(100% - 50px);\n      left: 0;\n      top: 39px;\n      box-shadow: 0 10px 20px 0 rgba(0,0,0,.25);\n      position: absolute;\n      z-index: -1;\n    }\n  }\n'], ['\n  border-radius: 0px;\n  padding: 15px 20px;\n  cursor: pointer;\n  /* font-family: \'Montserrat, Arial, sans-serif\'; */\n  background-color:  ', ';\n  color:  ', ';\n  background: ', ';\n  border: 1px solid #6CB557;\n  text-transform: uppercase;\n  transition: ', ';\n  position: relative;\n  &:hover {\n    color: #fff;\n    background: linear-gradient(90deg,#009677 0,#50b848 100%);\n    &:before {\n      content: \'\';\n      display: block;\n      height: 10px;\n      width: calc(100% - 50px);\n      left: 0;\n      top: 39px;\n      box-shadow: 0 10px 20px 0 rgba(0,0,0,.25);\n      position: absolute;\n      z-index: -1;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.button(_templateObject, function (props) {
  return props.theme === 'primary' ? 'white' : '#6CB557';
}, function (props) {
  return props.theme === 'primary' ? '#6CB557' : 'white';
}, function (props) {
  return props.theme === 'primary' ? '#fff' : 'linear-gradient(90deg,#009677 0,#50b848 100%)';
}, function (props) {
  return props.theme === 'primary' ? 'all 0.01s ease-in-out' : 'all 0.5s ease-in-out';
});

var Buttom_OM = function Buttom_OM(props) {
  var theme = props.theme;
  return React.createElement(Container, {
    theme: theme
  }, props.children);
};

export default Buttom_OM;